import {
  GLOBAL_CHANGE_SECTION
} from "./actions.type";
import {
  STATE_GLOBAL_SECTION_SET
} from "./mutations.type";

const state = {
  section: null
}

const getters = {
  section(state) {
    return state.section;
  }
}

const actions = {
  [GLOBAL_CHANGE_SECTION](context, sectionName) {
    context.commit(STATE_GLOBAL_SECTION_SET, sectionName);
  }
}

const mutations = {
  [STATE_GLOBAL_SECTION_SET](state, sectionName) {
    state.section = sectionName;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
};